import React, { useEffect, useState } from 'react'
import './HeroSectionBox.css'
import hero from '../image/club/hero-img.jpg'
import { FaLocationDot } from "react-icons/fa6";
import { API_BASE_URL } from '../../utils';
import FooterAppDownloadModal from '../../Feed Page/custom-comp/FooterAppDownloadModal';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

import ProfileImg from '../../Assets/profile.png';
import tulips from '../../Assets/tulips.svg';
import offerBG from '../../Assets/offer-icon-bg.svg';
import preBooking from '../../Assets/Pre-Booking.svg';
import payBil from '../../Assets/pay-bil.svg';
import earnNow from '../../Assets/earn-now.svg';
import PartywittyOffers from './PartywittyOffers';


function HeroSectionBox({ id, data, bidInfo, isPartyPackege, clubData }) {

    const url = `${API_BASE_URL}/master/assets/uploads/`;

    const [showModal, setShowModal] = useState(false);

    const navigate = useNavigate();
    const { packagedetail, title, tab, clubInfo, } = useParams();


    // Tab definitions
    const tabs1 = ['menu', 'package', 'event', 'gallery', 'teaser', 'about', 'review'];
    const tabs2 = ['menu', 'event', 'gallery', 'teaser', 'about', 'review'];
    const validTabs = !isPartyPackege ? tabs1 : tabs2;

    // Normalize URL tab param
    const normalizedTab = validTabs.includes(tab?.toLowerCase()) ? tab.toLowerCase() : 'menu';

    const [activeTab, setActiveTab] = useState(normalizedTab);

    useEffect(() => {
        setActiveTab(normalizedTab);
    }, [normalizedTab]);

    // Hero content per tab
    const contentMap = {
        menu: {
            heading: "You've got 500 🥕 Carrots ready to use.",
            subheading: "Use them to book your table FREE at the hottest party spots in town.",
            link: "/package-lead-form"
        },
        package: {
            heading: "Your 500 🥕 Carrots are ready – let the savings begin!",
            subheading: "🎉 Use them to book the exclusive party packages - Food, Drinks, Decor, DJs & more at unbeatable deals.",
            link: "/package-lead-form"
        },
        event: {
            heading: "Your 500 🥕 Carrots are ready – let the party begin!",
            subheading: "🎉 Use them to explore and book exciting club events – Live DJs, Theme Nights, Special Performances & more at unbeatable deals.",
            link: "/package-lead-form"
        },
        gallery: {
            heading: "Your 500 🥕 Carrots credited to your wallet.",
            subheading: "Enjoy tasty food, cool drinks, and a stylish vibe — see it all in these pictures.",
            link: "/package-lead-form"
        },
        teaser: {
            heading: "Your earned 500🥕Carrots – your party currency!",
            subheading: "From live music and DJ nights to dazzling lights and vibrant crowd energy — get a real taste of the party scene.",
            link: "/package-lead-form"
        },
        about: {
            heading: "You’ve got 500 🥕 Carrots in your wallet !!",
            subheading: "Feel the rhythm with live music, stunning lighting, and an unforgettable crowd atmosphere.",
            link: "/package-lead-form"
        },
        review: {
            heading: "Your experience matters! 📝",
            subheading: "Check reviews or leave your own to help others plan the perfect party.",
            link: "/review-form"
        }
    };

    

    const currentContent = contentMap[activeTab] || {
        heading: "Welcome to PartyWitty!",
        subheading: "Book through our app for exclusive perks.",
        link: "/"
    };



    return (
        <>
            <div className="vcdp-HeroSectionBox">
                <div className="vcdp-container">

                    {/* <div className='vcdp-HeroSectionBox-content'>
                        <div className='vcdp-HeroSectionBox-content-text'>
                            <h3>{currentContent.heading}</h3>
                            <h5>{currentContent.subheading}</h5>
                        </div>
                        <div className='vcdp-HeroSectionBox-content-btn'>
                            <button
                                className='vcdp-hero-btn'
                                onClick={() => navigate(currentContent.link)}
                            >
                                Reserve Now
                            </button>
                        </div>
                    </div> */}

                    <div className="vcdp-hero-img-section">
                        <div className="vcdp-hero-img">

                            {isPartyPackege ? (
                                <>
                                    {data?.thumbnail ? (
                                        <img src={`${url}${data.thumbnail} `} alt="Banner" />)
                                        : (
                                            <img src={hero} alt="Default Banner" />
                                        )}
                                </>
                            ) : (
                                <>
                                    {Array.isArray(data?.banner) && data.banner.length > 0 ? (
                                        <img src={`${url}${data.banner[0].img}`} alt="Banner" />
                                    ) : (
                                        <img src={hero} alt="Default Banner" />
                                    )}
                                </>
                            )}



                            <div className='vcdp-hero-img-overlay-bg'></div>
                            <div className="vcdp-hero-text-overlay">
                                <div className="vcdp-hero-text-1 d-flex flex-column gap-2">
                                    {
                                        isPartyPackege ? (
                                            <>
                                                <h3>{data?.title}</h3>
                                                <span>{data?.clubName}</span>
                                            </>
                                        ) :

                                            <div className='club-com d-flex align-items-center gap-2'>
                                                <div className='profile-img-club'>
                                                    <img width="24px" src={ProfileImg} alt="profile" />
                                                </div>

                                                <h5 className='font-18 text-white'>{data?.name}</h5>

                                                <div className='ratting-review-profile d-flex align-items-center gap-1 font-14'>

                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path d="M19.3755 7.94141H12.202L10.0005 1.25L7.79892 7.94141H0.625488L6.49307 12.0586L4.20791 18.75L10.0005 14.6031L15.7931 18.75L13.5036 12.0586L19.3755 7.94141Z" fill="#FACC15" stroke="#FACC15" />
                                                    </svg> 4.3


                                                </div>

                                                <a className='text-underline text-white font-14' href=''> Review (03) </a>

                                            </div>
                                    }
                                    {data.areaName && (
                                        <>
                                            <div
                                                className='edpdcsdt-data'
                                                data-tooltip-id="address-tooltip"
                                                data-tooltip-content={data?.address} // full address
                                            >
                                                <div className='text-white d-flex align-items-center font-14'>
                                                    <span className='icon-span-24'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" fill="none">
                                                            <path d="M12.8332 7.33382C12.8332 11.8709 6.99984 15.7597 6.99984 15.7597C6.99984 15.7597 1.1665 11.8709 1.1665 7.33382C1.1665 5.78673 1.78109 4.30299 2.87505 3.20903C3.96901 2.11507 5.45274 1.50049 6.99984 1.50049C8.54693 1.50049 10.0307 2.11507 11.1246 3.20903C12.2186 4.30299 12.8332 5.78673 12.8332 7.33382Z" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M6.99962 9.27829C8.07351 9.27829 8.94406 8.40773 8.94406 7.33385C8.94406 6.25996 8.07351 5.3894 6.99962 5.3894C5.92573 5.3894 5.05518 6.25996 5.05518 7.33385C5.05518 8.40773 5.92573 9.27829 6.99962 9.27829Z" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </span>{" "}
                                                    {(data?.areaName || "--") + ", " + (data?.cityName || "--")}


                                                </div>

                                            </div>
                                            <p className='text-whtie font-14 m-0'>it's a bar and Brewery rooftop  ...</p>

                                            <Tooltip id="address-tooltip" place="top" style={{
                                                maxWidth: '250px',       // control width
                                                whiteSpace: 'normal',    // allow wrapping
                                                wordBreak: 'break-word', // break long words
                                                padding: '8px',          // optional
                                            }} />
                                        </>
                                    )}
                                    {/* <FaLocationDot />{data?.address}</h5> */}
                                    {/* <p>{data?.about?.description}</p> */}
                                </div>


                                {!id && (
                                    <>
                                        <div className="vcdp-hero-text-2-hero">
                                            <h4>Open from {data?.open_time}</h4>
                                            <h4>Close at {data?.close_time}</h4>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>


                    <PartywittyOffers
                        data={isPartyPackege ? clubData : data}
                    />



                </div>
            </div>
            <FooterAppDownloadModal isOpen={showModal} onClose={() => setShowModal(false)} />
        </>
    )
}

export default HeroSectionBox
